import React from 'react';

function AveragePay(props) {
  const {
    titleText,
    plainText,
    modalStyling,
    titleTextPrimary,
    overRideStyles,
  } = {
    ...props,
  };
  return (
    <div className="avg-column">
      <p
        className={['onestop-title-text', overRideStyles].join(' ')}
        style={modalStyling ? null : titleTextPrimary}
      >
        {titleText}
      </p>
      <p
        className="onestop-plain-text"
        style={modalStyling ? titleTextPrimary : null}
      >
        {plainText}
      </p>
    </div>
  );
}

export default AveragePay;
